module.exports = __webpack_public_path__ + "assets/img/tsaLogo.4a40cef8.png";